export default __webpack_public_path__ + "static/media/17-Years-1.9197abd6.svg";